var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prevent"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("还未登录，请在右侧加载项中登录AIMS系统!")])]),_c('div',{staticClass:"footer"})])}]

export { render, staticRenderFns }